import React, { useEffect, useState } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import { useDispatch, useSelector } from 'react-redux'
import { useLocation } from 'react-router-dom';
import Select from 'react-select'
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from 'react-bootstrap/Modal';
import moment from "moment";
import { displayCurrencySymbolLeft, displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import {
    assetDetailRequest, assignAssetRequest, assignAssetRequestStatus,
    unAssignAssetRequest, unAssignAssetRequestStatus, updateAssetStatusRequest, updateAssetStatusRequestStatus
} from '../../../redux/asset/asset.action'
import CommonFormBorder from "../../../components/common-form-border/commonFormBorder";
import { checkFunctionalityPermission, PERMISSION_SUB_TYPE, PERMISSION_TYPE } from "../../../utils/PermissionUtil";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";
import { employeeListRequest } from '../../../redux/employee/employee.action'
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";

const AssetDetails = props => {
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector(state => state.user)
    const { assetDetailSuccess, assetDetailError, assignAssetSuccess, assignAssetError,
        assignAssetReqStatus, unAssignAssetSuccess, unAssignAssetError, unAssignAssetReqStatus,
        updateAssetStatusSuccess, updateAssetStatusError, updateAssetStatusReqStatus } = useSelector(state => state.asset)
    const [isLoading, setLoading] = useState(false)
    const dispatch = useDispatch()
    const { state } = useLocation()
    const [showStatusChangeModal, setShowStatusChangeModal] = useState(false)
    const [selectedStatus, setSelectedStatus] = useState()
    let STATUS_LIST = [
        { key: APP_CONSTANTS.ASSET_STATUS.MAINTENANCE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.ASSET_STATUS.MAINTENANCE) },
        { key: APP_CONSTANTS.ASSET_STATUS.DISPOSED, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.ASSET_STATUS.DISPOSED) }
    ]
    const { employeeListSuccess, employeeListError } = useSelector(state => state.employee)
    const [selectedEmployee, setSelectedEmployee] = useState(null)
    const [startDate, setStartDate] = useState(new Date())
    const [endDate, setEndDate] = useState(new Date())
    const [conditionAtAssignment, setConditionAtAssignment] = useState('')
    const [conditionAtUnAssignment, setConditionAtUnAssignment] = useState('')
    const [assignEmployeeModal, setShowAssignEmployeeModal] = useState(false)
    const [searchQuery, setSearchQuery] = useState('')
    const [showUnAssignEmployeeModal, setShowUnAssignEmployeeModal] = useState(false)

    useEffect(() => {
        fetchAssetDetails()
    }, [])

    const fetchAssetDetails = () => {
        setLoading(true)
        const data = {
            id: state.assetId,
            params: {
                businessId: state.businessId,
                locationId: state.locationId
            }
        }
        dispatch(assetDetailRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(assetDetailSuccess)) {
            setLoading(false)
            if (assetDetailSuccess.data.status === APP_CONSTANTS.ASSET_STATUS.MAINTENANCE) {
                STATUS_LIST.unshift({
                    key: APP_CONSTANTS.ASSET_STATUS.AVAILABLE, value: removeSpecialCharAndChangeToPascal(APP_CONSTANTS.ASSET_STATUS.AVAILABLE)
                })
            }
        } else if (!isEmpty(assetDetailError)) {
            setLoading(false)
        }
    }, [assetDetailSuccess, assetDetailError])

    useEffect(() => {
        if (!isEmpty(employeeListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(employeeListError)) {
            setLoading(false)
        }
    }, [employeeListSuccess, employeeListError])

    useEffect(() => {
        if (assignAssetReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(assignAssetSuccess.data?.message)
            fetchAssetDetails()
        } else if (assignAssetReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(assignAssetError.message)
        }
        if (assignAssetReqStatus?.length) {
            dispatch(assignAssetRequestStatus(''))
        }
    }, [assignAssetSuccess, assignAssetError, assignAssetReqStatus])

    useEffect(() => {
        if (unAssignAssetReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(unAssignAssetSuccess.data?.message)
            fetchAssetDetails()
        } else if (unAssignAssetReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(unAssignAssetError.message)
        }
        if (unAssignAssetReqStatus?.length) {
            dispatch(unAssignAssetRequestStatus(''))
        }
    }, [unAssignAssetSuccess, unAssignAssetError, unAssignAssetReqStatus])

    useEffect(() => {
        if (updateAssetStatusReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateAssetStatusSuccess.data?.message)
            fetchAssetDetails()
        } else if (updateAssetStatusReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateAssetStatusError.message)
        }
        if (updateAssetStatusReqStatus?.length) {
            dispatch(updateAssetStatusRequestStatus(''))
        }
    }, [updateAssetStatusSuccess, updateAssetStatusError, updateAssetStatusReqStatus])

    const isPermissionAllowed = (pType) => {
        if (pType === PERMISSION_SUB_TYPE.ASSET.ADD_ASSET) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.ASSET, PERMISSION_SUB_TYPE.ASSET.ADD_ASSET, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET) {
            return checkFunctionalityPermission(user, PERMISSION_SUB_TYPE.ASSET, PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET, employeeSelectedBusiness, employeeSelectedLocation)
        } else if (pType === PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET) {
            return checkFunctionalityPermission(user, PERMISSION_TYPE.ASSET, PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET, employeeSelectedBusiness, employeeSelectedLocation)
        }
    }

    const getAmountWithCurrency = (e, amount) => {
        return (displayCurrencySymbolLeft(e.currencyRegion) ?
            <span>
                {e.currencySymbol} {amount}
            </span>
            : <span>
                {amount} {e.currencySymbol}
            </span>
        )
    }

    const getStatusClassname = (status) => {
        if (status === APP_CONSTANTS.ASSET_STATUS.ASSIGNED || status === APP_CONSTANTS.ASSET_ASSIGNMENT_STATUS.RETURNED) {
            return 'pd-status-container pd-status-container-new'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.MAINTENANCE) {
            return 'pd-status-container pd-status-container-in-progress'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.AVAILABLE || status === APP_CONSTANTS.ASSET_ASSIGNMENT_STATUS.ACTIVE) {
            return 'pd-status-container pd-status-container-complete'
        } else if (status === APP_CONSTANTS.ASSET_STATUS.DISPOSED || status === APP_CONSTANTS.ASSET_ASSIGNMENT_STATUS.OVERDUE) {
            return 'pd-status-container pd-status-container-cancelled'
        }
    }

    const handleAssignAssetClick = () => {
        setShowAssignEmployeeModal(true)
    }

    const handleAssignEmpSubmitClick = (isAssignToMe = false) => {
        if (!isAssignToMe && isEmpty(selectedEmployee)) {
            displayErrorToast('Employee not selected')
        } else if (isEmpty(assetDetailSuccess)) {
            displayErrorToast('Asset details not found. Please try again')
        } else if (isEmpty(startDate)) {
            displayErrorToast('Assignment start date not selected')
        } else if (isEmpty(conditionAtAssignment)) {
            displayErrorToast('Asset condition at assignment cannot be blank')
        } else {
            let userId
            let userType
            if (isAssignToMe) {
                if (isLoggedInUserBusiness(user)) {
                    userId = user.data.userDetails.userId
                    userType = user.data.userDetails.userType
                } else {
                    userId = user.data.userDetails.employeeId
                    userType = user.data.userDetails.userType
                }
            } else {
                userId = selectedEmployee.employeeId
                userType = selectedEmployee.userType
            }
            setLoading(true)
            const data = {
                assetId: state,
                id: userId,
                userType: userType,
                assignedBy: isLoggedInUserBusiness(user) ? user.data.userDetails.userId : user.data.userDetails.employeeId,
                assignedByUserType: user.data.userDetails.userType,
                startDate: moment(startDate).utc().format("YYYY-MM-DD hh:mm:ss A"),
                conditionAtAssignment: conditionAtAssignment
            }
            dispatch(assignAssetRequest(data))
            setShowAssignEmployeeModal(false)
        }
    }

    const handleUnAssignSubmitClick = () => {
        if (isEmpty(assetDetailSuccess)) {
            displayErrorToast('Asset details not found. Please try again')
        } else if (isEmpty(endDate)) {
            displayErrorToast('Assignment end date not selected')
        } else if (isEmpty(conditionAtUnAssignment)) {
            displayErrorToast('Asset condition at un-assignment cannot be blank')
        } else {
            if (isLoggedInUserEmployee(user) && parseFloat(assetDetailSuccess.data.assignedTo) === parseFloat(user.data.userDetails.employeeId) && assetDetailSuccess.data.assignedToUserType === user.data.userDetails.userType) {
                displayErrorToast('Cannot self un-assign asset')
            } else {
                setLoading(true)
                const data = {
                    assetId: state,
                    id: assetDetailSuccess.data.assignedTo,
                    userType: assetDetailSuccess.data.assignedToUserType,
                    endDate: moment(endDate).utc().format("YYYY-MM-DD hh:mm:ss A"),
                    conditionAtUnAssignment: conditionAtUnAssignment
                }
                dispatch(unAssignAssetRequest(data))
                setShowUnAssignEmployeeModal(false)
            }
        }
    }

    const handleUpdateStatusClick = () => {
        if (isEmpty(state)) {
            displayErrorToast('Something went wrong. Please try refreshing the page')
        } else if (isEmpty(selectedStatus)) {
            displayErrorToast('Asset status not selected')
        } else {
            setLoading(true)
            const data = {
                assetId: state,
                status: selectedStatus.key
            }
            dispatch(updateAssetStatusRequest(data))
            setShowStatusChangeModal(false)
        }
    }

    const fetchEmployeeList = () => {
        setLoading(true)
        const data = {
            businessId: state.businessId,
            locationId: state.locationId
        }
        if (!isEmpty(searchQuery)) {
            data.searchQuery = searchQuery
        }
        dispatch(employeeListRequest(data))
    }

    useEffect(() => {
        if (!isEmpty(selectedEmployee)) {
            handleAssignEmpSubmitClick(false)
        }
    }, [selectedEmployee])

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Asset Details' />
                {!isEmpty(assetDetailSuccess) && <CommonFormBorder>
                    <div className="pd-img-parent-container">
                        <div className="pd-img-container">
                            <img src={require('../../../assets/logo_togethra.png')} className="img" />
                        </div>
                    </div>
                    <div className="pd-status-row-container">
                        <div className={getStatusClassname(assetDetailSuccess.data.status)}>{removeSpecialCharAndChangeToPascal(assetDetailSuccess.data.status)}</div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.UPDATE_ASSET) && assetDetailSuccess.data.status !== APP_CONSTANTS.ASSET_STATUS.DISPOSED && <div className="ed-role-img-container"
                            onClick={() => { setShowStatusChangeModal(true) }}>
                            <img src={require('../../../assets/ic_edit_pen.png')} className="img" />
                        </div>}
                    </div>

                    <div className="pd-name-container">
                        <div className="pd-name-label">{assetDetailSuccess.data.name}</div>
                    </div>
                    <div className="pd-description-container">
                        <div className="pd-description-label">{assetDetailSuccess.data.details}</div>
                    </div>
                    {!isEmpty(assetDetailSuccess.data.category) && <div className="pd-icon-label">Type: {removeSpecialCharAndChangeToPascal(assetDetailSuccess.data.category)}</div>}
                    {!isEmpty(assetDetailSuccess.data.serialNumber) && <div className="pd-icon-label">Serial Number: {assetDetailSuccess.data.serialNumber}</div>}
                    {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.ADD_ASSET) && <div className="ad-purchase-parent-container">
                        <FormFieldLabel label='Purchase Information' />
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Purchase Cost</div>
                            <div className="ad-purchase-row-item-container">{getAmountWithCurrency(assetDetailSuccess.data, assetDetailSuccess.data.purchaseCost)}</div>
                        </div>
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Purchase Date</div>
                            <div className="ad-purchase-row-item-container">{moment.utc(assetDetailSuccess.data.pruchaseDate).local().format('DD MMM YYYY')}</div>
                        </div>
                        <div className="ad-purchase-row-container">
                            <div className="ad-purchase-row-item-container">Warranty Expiry</div>
                            <div className="ad-purchase-row-item-container">{moment.utc(assetDetailSuccess.data.warrantyExpiry).local().format('DD MMM YYYY')}</div>
                        </div>
                    </div>}
                    {!isEmpty(assetDetailSuccess.data.notes) && <div>
                        <FormFieldLabel label='Asset Notes' />
                        <div className="pd-description-label">{assetDetailSuccess.data.notes}</div>
                    </div>}
                    {!isEmpty(assetDetailSuccess.data.assignToDetails) && <div>
                        <FormFieldLabel label='Assigned To Details' />
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-container">
                                <img src={require('../../../assets/ic_user.png')} className="img" />
                            </div>
                            <div className="pd-icon-label">{assetDetailSuccess.data.assignToDetails.firstName} {assetDetailSuccess.data.assignToDetails.lastName}</div>
                        </div>
                        <div className="pd-icon-row-container">
                            <div className="pd-icon-key">{assetDetailSuccess.data.assignToDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? 'Employee Code:' : 'Role Type:'}</div>
                            <div className="pd-icon-label">{assetDetailSuccess.data.assignToDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? assetDetailSuccess.data.assignToDetails.employeeBusinessMapping[0].employeeCode : removeSpecialCharAndChangeToPascal(assetDetailSuccess.data.assignToDetails.userType)}</div>
                        </div>
                        {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET) && <div className="ad-un-assign-label" onClick={() => { setShowUnAssignEmployeeModal(true) }}>RETURN DEVICE</div>}
                    </div>}
                    <FormFieldLabel className='up-bold-label' label='Assignment History' />
                    {isEmpty(assetDetailSuccess.data.assignmentDetails) && <div className="content-error">No assignment history available</div>}
                    {!isEmpty(assetDetailSuccess.data.assignmentDetails) && <div className="td-comment-col-container">
                        {assetDetailSuccess.data.assignmentDetails.map(item => (<div className="td-comment-item-container">
                            <div className="pd-status-row-container">
                                <div className={getStatusClassname(item.status)}>{removeSpecialCharAndChangeToPascal(item.status)}</div>
                            </div>
                            <div className="td-comment-date">Assignment Date: {moment.utc(item.startDate).local().format('DD/MM/YYYY')} - {!isEmpty(item.endDate) ? moment.utc(item.endDate).local().format('DD/MM/YYYY') : 'N/A'}</div>
                            <div className="ad-assignment-name">{item.assignedToDetails.firstName} {item.assignedToDetails.lastName}</div>
                            <div className="ad-assignment-type">{item.assignedToDetails.userType === APP_CONSTANTS.USER_ROLE_TYPE.EMPLOYEE ? item.assignedToDetails.employeeCode : removeSpecialCharAndChangeToPascal(item.assignedToDetails.userType)}</div>
                            <div className="td-comment-date m-0">Condition at Assignment</div>
                            <div className="pd-description-label">{!isEmpty(item.conditionAtAssignment) ? item.conditionAtAssignment : 'N/A'}</div>
                            <div className="td-comment-date m-0">Condition on Return</div>
                            <div className="pd-description-label">{!isEmpty(item.conditionAtUnAssignment) ? item.conditionAtUnAssignment : 'N/A'}</div>
                        </div>))}
                    </div>}
                    {isPermissionAllowed(PERMISSION_SUB_TYPE.ASSET.ASSIGN_ASSET) && assetDetailSuccess.data.status === APP_CONSTANTS.ASSET_STATUS.AVAILABLE && <ButtonRow>
                        <CommonButton label='Assign Asset'
                            onClick={() => { handleAssignAssetClick() }}
                        />
                    </ButtonRow>}
                </CommonFormBorder>}
            </CommonScreenContent>
            <Modal
                onHide={() => { setShowStatusChangeModal(false) }}
                show={showStatusChangeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Update Asset Status
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Select Asset Status' />
                    <Select
                        className='select-full-width-no-border'
                        value={selectedStatus}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={STATUS_LIST}
                        placeholder='Select Status'
                        onChange={e => setSelectedStatus(e)} />
                    <ButtonRow>
                        <CommonButton label='Update'
                            onClick={() => {
                                handleUpdateStatusClick()
                            }}
                        />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowAssignEmployeeModal(false) }}
                show={assignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Select employee
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel className='up-bold-label' label='Assignment Details' />
                    <div className="as-date-parent-container-full">
                        <FormFieldLabel label='Start Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={startDate}
                            minDate={new Date()}
                            onChange={(date) => {
                                setStartDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    <CommonInputFloatFull
                        type='text'
                        id='startDate'
                        onChange={e => setConditionAtAssignment(e.target.value)}
                        placeholder='Asset Condition'
                        value={conditionAtAssignment}
                        multiline={true}
                        rows={2} />
                    <FormFieldLabel className='up-bold-label' label='User Details' />
                    <div className="ol-search-parent-container">
                        <div className="ol-search-row-parent-container">
                            <div className="ol-search-input-container">
                                <input type="text" className="ol-input-no-border" value={searchQuery} onChange={e => setSearchQuery(e.target.value)} placeholder="Search Employee" />
                            </div>
                            <div className="ol-search-icon-container" onClick={() => { fetchEmployeeList() }}>
                                <img src={require('../../../assets/ic_search_orange.png')} className="img" />
                            </div>
                        </div>
                    </div>
                    {!isEmpty(employeeListSuccess) && <div className="ae-emp-list-container">
                        {!isEmpty(employeeListSuccess.data) && employeeListSuccess.data.map(e => (<div className="ae-emp-list-item-container">
                            <div className="ae-emp-list-item-content-container">
                                <div className="ae-emp-name-label">{e.firstName} {e.lastName}</div>
                                <div className="ae-emp-code-label">{e.employeeCode}</div>
                                <div className="ae-emp-name-label">{e.role}</div>
                            </div>
                            <div className="ae-row-btn-container" onClick={() => {
                                setSelectedEmployee(e)
                            }}>Assign</div>
                        </div>))}
                    </div>}
                    {!isEmpty(employeeListError) && <div className="content-error">{employeeListError.message}</div>}
                    <div className="td-or-label">OR</div>
                    <div className="td-or-btn-container">
                        <CommonButton label='Assign to me' onClick={() => { handleAssignEmpSubmitClick(true) }} />
                    </div>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => { setShowUnAssignEmployeeModal(false) }}
                show={showUnAssignEmployeeModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    Un-Assign Asset
                </Modal.Header>
                <Modal.Body>
                    <div className="as-date-parent-container-full">
                        <FormFieldLabel label='End Date' />
                        <DatePicker
                            className="as-date-container"
                            selected={endDate}
                            minDate={new Date()}
                            onChange={(date) => {
                                setEndDate(date)
                            }}
                            dateFormat="MMMM d, yyyy"
                        />
                    </div>
                    <CommonInputFloatFull
                        type='text'
                        id='startDate'
                        onChange={e => setConditionAtUnAssignment(e.target.value)}
                        placeholder='Asset Condition'
                        value={conditionAtUnAssignment}
                        multiline={true}
                        rows={2} />
                    <div className="td-or-btn-container">
                        <CommonButton label='Submit' onClick={() => { handleUnAssignSubmitClick() }} />
                    </div>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default AssetDetails